import { render, staticRenderFns } from "./pageheader.vue?vue&type=template&id=94fe36be&scoped=true&"
import script from "./pageheader.vue?vue&type=script&lang=js&"
export * from "./pageheader.vue?vue&type=script&lang=js&"
import style0 from "./pageheader.vue?vue&type=style&index=0&id=94fe36be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fe36be",
  null
  
)

export default component.exports